import { render, staticRenderFns } from "./SolicitudCertificado.vue?vue&type=template&id=4038736a&scoped=true"
import script from "./SolicitudCertificado.vue?vue&type=script&lang=js"
export * from "./SolicitudCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4038736a",
  null
  
)

export default component.exports